// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-2ac8114b]{display:flex;flex-grow:1;align-items:center;justify-content:center;position:relative}.image[data-v-2ac8114b]{position:absolute;height:100%;width:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
